// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2WGfj","approved":"Status_approved__1l0xo","rejected":"Status_rejected__25KJ7","expired":"Status_expired__3_lRe","label":"Status_label__14pO0"};